<template>
    <div class="modal-content">
        <div class="modal-box modal-save columns is-multiline">
          <div class="column is-12 modal-save-column flex-center">

            <!-- start -->
            <div v-if="showFeedback === null" :class="{'fade-out': showFeedback !== null}" class="columns is-multiline">

              <div v-if="!saveView">
                <!-- new project -->
                <div v-if="!project.projectId">
                  <div class="modal-save-button flex-center" @click="changeView('new')">
                    <icon class="large-svg flex fill-primary" name="cloud-download"></icon>
                    <span>{{$t('modal-save.saveFileButtonLabel')}}</span>
                  </div>
                </div>

                <!-- existing project -->
                <div v-else>
                  <h5 class="text-center full-width">{{$t('modal-save.saveTitle')}}</h5>
                  <div class="column is-12 sdg-graphic-container flex-center">
                    <div class="modal-save-button flex-center" @click="changeView('overwrite')">
                      <icon class="large-svg flex fill-primary" name="overwrite"></icon>
                      <span>{{$t('modal-save.replace')}}</span>
                    </div>
                    <div class="modal-save-button flex-center" @click="changeView('version')">
                      <icon class="large-svg flex fill-primary" name="cloud-download"></icon>
                      <span>{{$t('modal-save.new')}}</span>
                    </div>
                  </div>
                  <div v-html="$t('modal-save.replaceText')" class="white"></div>
                  <div v-html="$t('modal-save.newText')" class="white"></div>
                </div>
              </div>
              <div v-else>
                <!-- save view = new -->
                <div v-if="saveView === 'new'">
                  <label class="label white text-center">{{$t('modal-save.addComment')}}</label>
                  <div class="control" style="min-width: 300px;">
                    <textarea class="textarea" v-model="comment"></textarea>
                  </div>
                  <div class="flex-center flex-direction-column">
                    <a @click="saveFile('new')" class="button save-button">
                      <icon class="small-svg flex" name="cloud-download"></icon>
                      <span>{{$t('global.save')}}</span>
                    </a>
                  </div>
                </div>
                <!-- save view = overwrite -->
                <div v-if="saveView === 'overwrite'">
                  <label class="label white text-center">{{$t('modal-save.addComment')}}</label>
                  <div class="control" style="min-width: 300px;">
                    <textarea class="textarea" v-model="comment"></textarea>
                  </div>
                  <div class="flex-center flex-direction-column">
                    <a @click="saveFile('overwrite')" class="button save-button">
                      <icon class="small-svg flex" name="overwrite"></icon>
                      <span>{{$t('modal-save.overwriteVersion')}}</span>
                    </a>
                  </div>
                </div>
                <!-- save view = version -->
                <div v-if="saveView === 'version'">
                  <label class="label white text-center">{{$t('modal-save.addComment')}}</label>
                  <div class="control" style="min-width: 300px;">
                    <textarea class="textarea" v-model="comment"></textarea>
                  </div>
                  <div class="flex-center flex-direction-column">
                    <a @click="saveFile('version')" class="button save-button">
                      <icon class="small-svg flex" name="cloud-download"></icon>
                      <span>{{$t('modal-save.newVersion')}}</span>
                    </a>
                  </div>
                </div>
              </div>

            </div>

            <!-- Spinner -->
            <div v-else-if="showFeedback === true" :class="{'fade-in': showFeedback}" class="column is-12 sdg-graphic-container">
              <div class="flex-center">
                <icon class="save-spinner-svg sdg-spinner flex" name="sdg-wheel"></icon>
              </div>
            </div>

            <!-- Loading done -->
            <div v-else-if="showFeedback === false" class="columns is-multiline">
              <div class="column is-12 sdg-graphic-container flex-center">
                <div class="rotate-in-center">
                  <div class="saved-checkmark-circle flex-center">
                    <icon class="large-svg flex fill-green" name="checkmark"></icon>
                  </div>
                </div>
              </div>
              <div class="column is-12 flex-center flex-direction-column">
                <div>
                  <span class="spinner-saved-text">{{$t('modal-save.spinnerSavedFileName')}}</span><span class="spinner-saved-text semi-bold">{{project.contentJson.name}}</span>
                </div>
              </div>
            </div>

            <!-- Loading failed -->
            <div v-else-if="showFeedback === 'failed'">
              <div class="column is-12 sdg-graphic-container flex-center">
                <div class="rotate-in-center">
                  <div class="saved-checkmark-circle flex-center">
                    <icon class="large-svg flex fill-red" name="clear"></icon>
                  </div>
                </div>
              </div>
              <div class="column is-12 flex-center flex-direction-column">
                <div>
                  <span class="spinner-saved-text">{{$t('modal-save.spinnerErrorSavedFileName')}}</span><span class="spinner-saved-text semi-bold">{{project.contentJson.name}}</span>
                  <p v-if="errorProjectName">{{errorProjectName}}</p>
                </div>
              </div>
            </div>

          </div>
          <div class="column is-12 flex-center">
            <div class="columns is-multiline">
              <div v-if="showFeedback === true" class="column is-12 flex-center fade-in">
                <span class="spinner-feedback-text">
                  {{$t('modal-save.spinnerFeedbackText')}}
                </span>
              </div>
              <div v-else class="column is-12 flex-center flex-direction-column">
                <span v-if="showFeedback === null" class="save-feedback-text">{{$t('modal-save.exitNoSave')}}</span>
                <p v-else class="save-feedback-text">{{$t('modal-save.exitWithSave')}}</p>
                <button class="button exit-button" @click="goToProjects()">{{$t('modal-save.exitFileButtonLabel')}}</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'save-modal',
  data () {
    return {
      showFeedback: null,
      errorProjectName: null,
      saveView: null,
      comment: ''
    }
  },
  computed: {
    ...mapGetters({
      project: 'getProject'
    })
  },
  methods: {
    ...mapActions({
      handleSaveProject: 'handleSaveProject',
      setActivePageCode: 'setActivePageCode',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      validateProjectName: 'validateProjectName',
      resetAllInVuex: 'resetAllInVuex'
    }),
    async saveFile (operator) {
      // new, overwrite, version
      this.errorProjectName = null
      this.showFeedback = true
      this.project.contentJson.comment = this.comment
      if (operator === 'new') {
        try {
          const responseValidateName = await this.validateProjectName(this.project.contentJson.name)
          if (responseValidateName) {
            try {
              await this.handleSaveProject(operator)
              this.showFeedback = false
            } catch (err) {
              this.showFeedback = 'failed'
              console.log('error saving project', err)
            }
          } else {
            this.showFeedback = 'failed'
            this.errorProjectName = this.$t('modal-project.modalNewProjectErrorProjectName')
          }
        } catch (err) {
          console.log('error validating project name', err)
        }
      } else {
        try {
          await this.handleSaveProject(operator)
          this.showFeedback = false
        } catch (err) {
          this.showFeedback = 'failed'
          console.log('error saving project', err)
        }
      }
    },
    goToProjects () {
      this.setShowModal(false)
      this.setModalType(null)
      this.setModalData(null)
      this.resetAllInVuex()
      this.setActivePageCode('project')
    },
    changeView (view) {
      this.comment = ''
      if (view === 'overwrite') {
        this.comment = this.project.contentJson.comment
      }
      this.saveView = view
    }
  }
}
</script>
